import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import { MdOutlineFlag } from "react-icons/md";

import Button from "../../../../Button";
import ProjectGoal from "../../../../modals/common/ProjectGoalModal";
import ProjectStepsModal from "../../../../modals/common/ProjectStepsModal";

const CodeSolutionsHeader = ({ rest }) => {
  const { t } = useTranslation();
  const projectGoalModalRef = useRef();
  const projectStepsModalRef = useRef();

  const openProjectGoalModal = (projectData) => projectGoalModalRef.current?.openModal(projectData);
  const openProjectStepsModal = (projectData) => projectStepsModalRef.current?.openModal(projectData);

  return (
    <div className="mb-2 flex items-center justify-between">
      {rest.lessonName}
      {rest?.projectGoal?.projectGoal ? (
        <div className="flex items-center space-x-2">
          <Button
            color="yellow"
            variant="outlined"
            iconLeft={<MdOutlineFlag />}
            label={t("check_project_goal")}
            onClick={() => openProjectGoalModal(rest.projectGoal)}
          />
        </div>
      ) : (
        <div className="flex items-center space-x-2">
          <Button
            color="yellow"
            variant="outlined"
            iconLeft={<MdOutlineFlag />}
            label={t("check_project_steps")}
            onClick={() => openProjectStepsModal(rest)}
          />
        </div>
      )}
      <ProjectGoal ref={projectGoalModalRef} />
      <ProjectStepsModal ref={projectStepsModalRef} />
    </div>
  );
};

export default CodeSolutionsHeader;
